jQuery(document).ready(function ($) {
  function showSpinner() {
    if (window.innerWidth <= 768) {
      $(".search-spinner").css("display", "inline-block");
    }
  }

  function hideSpinner() {
    $(".search-spinner").css("display", "none");
  }

  $("#search-form").on("submit", function (e) {
    showSpinner();
    let search_term = $("#search-form").find(".search__field").val();

    $.ajax({
      type: "POST",
      dataType: "json",
      url: search_spinner.ajaxurl,
      data: { action: "search_spinner", term: search_term },
      complete: function () {
        hideSpinner();
      },
    });
  });

  $("#lucky-btn").on("click", function (e) {
    e.preventDefault();
    showSpinner();

    let search_term = $(this)
      .closest(".search_container")
      .find(".search__field")
      .val();
    let data = `&action=show_lucky_post&term=${search_term}`;

    $.ajax({
      type: "POST",
      dataType: "html",
      url: show_lucky_post.ajaxurl,
      data: data,
      success: function (res) {
        window.location.href = JSON.parse(res).url;
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
        hideSpinner();
      },
    });

    $(window).on("beforeunload", function () {
      hideSpinner();
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var formSkeletonLoader = document.getElementById("form-skeleton-loader");
  var resultsSkeletonLoader = document.getElementById(
    "results-skeleton-loader"
  );
  if (formSkeletonLoader) {
    formSkeletonLoader.style.display = "none";
  }
  if (resultsSkeletonLoader) {
    resultsSkeletonLoader.style.display = "none";
  }
});
